<script>
export default {
    name: 'BaseCalendarViewSchedule',
};
</script>

<script setup>
defineProps({
    date: {
        type:     Date,
        required: true,
    },
});
</script>

<template>
    <div class="flex flex-col">
        Schedule: Under Development
    </div>
</template>
